import React, { useEffect, useState } from 'react';
import { Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';

export default function SimulationModal({  simulation, onTriggerCreate, onTriggerUpdate }) {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [attacks, setAttacks] = useState([]);

  const [formData, setFormData] = useState({
      id: '',
      attack_type_id: '',
      attack_type: '',
      sequence: '',
      description: '',
      media: '',
      active: false
  });

  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  const handleOpen = () => {
    setOpen(true);
    setTitle('Create Simulation');
    setFormData({ ...formData, id: '', attack_type_id: '', attack_type: '', sequence: '', description: '', media: '', active: '' });
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle('Update Simulation');
    setFormData({ ...formData, id: formData.id, attack_type_id: formData.attack_type_id, attack_type: formData.attack_type, sequence: formData.sequence, description: formData.description, media: formData.media, active: formData.active });
  }

  const handleUpdate = async (event) => {
      const result = await createSimulation(event);
      
      if (result === 'success') {
        setOpen(false);
        if ( title === 'Create Simulation' ) {
          onTriggerCreate(formData);
        } else {
          onTriggerUpdate(formData);
        }      
      } else {
        toast.error(`Creation Error : ${result}`);
      }
  }

  const handleClose = async () => {
    setOpen(false);
    if (formData.id === '') {    
      await setFormData({ ...formData, id: '', attack_type_id: '', attack_type: '', sequence: '', description: '', media: '', active: '' });
    }
  }
  
  const handleInputChange = (field) => (e) => {      
      const value = e.target.value;

      if (field === 'attack_type_id') {          
          const attack = attacks.filter(attack => attack.id === value);
          setFormData({ ...formData, [field]: value, attack_type: attack[0].label });
      } else {
        setFormData({ ...formData, [field]: value });
      }
  }

  const fetchActiveAttacks = async () => {
      try {
              
          const response = await fetch(`${process.env.REACT_APP_API}/attackTypes/activeAttacks`);            
          if (!response.ok) {
              toast.error(`HTTP error! status: ${response.status}`);
          } else {
              const json = await response.json();
              setAttacks(json.data);
          }
      } catch (error) {
          toast.error(error);
      } 
  };
  

  const createSimulation = async (event) => {
    event.preventDefault();
    let result = null;

    try {
        
        if (formData.id === '') {
          const response = await fetch(`${process.env.REACT_APP_API}/simulator/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
        } else {
            const response = await fetch(`${process.env.REACT_APP_API}/simulator/update`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
          }
          return result.message;
    } catch (error) {
      toast.error('Network error.  Please try again: ', error);
      return false;
    }
  }
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    fetchActiveAttacks();
    if (simulation.id !== undefined) {
      setFormData(simulation);
    }     
    setLoading(false);
  }, [simulation]);

  if (!loading) {
    return (
      <>
          { formData.id === "" && 
            <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
              Add New
            </Button>
          }
          
          { formData.id !== '' && 
            <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
                <EditIcon />
            </Button>
          }
          
          <Modal 
            open={open} 
            onClose={handleClose}
            style={{
              overlay: {
                backgroundColor: '#080030', // Semi-transparent black
              },
              content: {
                backgroundColor: '#080030',
              },
            }}
          >
              <Box sx={{color: 'white', p: 4 }}>
                  <Box
                    component={Paper}
                    elevation={3}
                    sx={{
                      
                      mx: 'auto',
                      width: 800,
                      bgcolor: '#1e1e1e',
                      p: 2,
                    }}
                  >
                    <Typography variant="h4" component="h2" color="white" mb={2}>
                      {title}
                    </Typography>

                    <Box component="form" onSubmit={handleUpdate}>
                      <Stack spacing={2}>
                        <TextField
                          select
                          required
                          fullWidth                          
                          label="Attack Type"
                          value={formData.attack_type_id}
                          onChange={handleInputChange('attack_type_id')}
                          sx={ textFieldStyles }
                        >
                          {attacks.map((attack) => (
                            <MenuItem key={attack.id} value={attack.id}>
                              {attack.label}
                            </MenuItem>
                          ))}
                        </TextField>
                        <TextField
                          required
                          fullWidth
                          label="Sequence"
                          type="number"
                          value={formData.sequence}
                          onChange={handleInputChange('sequence')}
                          sx={ textFieldStyles }
                        />
                        <TextField
                          required
                          fullWidth
                          multiline
                          label="Description"
                          rows={5}
                          value={formData.description}
                          onChange={handleInputChange('description')}
                          sx={ textFieldStyles }
                        />
                        <TextField
                          fullWidth
                          label="Media"
                          value={formData.media}
                          onChange={handleInputChange('media')}
                          sx={ textFieldStyles }
                        />
                        <TextField
                          select
                          required
                          fullWidth
                          label="Active"
                          value={formData.active}
                          onChange={handleInputChange('active')}
                          sx={ textFieldStyles }
                          >
                          {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </TextField>    
                      
                    
                    <ButtonGroup 
                      size="small"
                      variant="contained" 
                      aria-label="Basic button group" 
                      fullWidth
                      sx={{ mt:2 }}
                    >
                      <Button
                        onClick={handleClose}
                        type="cancel"
                        variant="contained"
                        sx={ Styles.buttonStyle }
                      >
                        Cancel
                      </Button>              
                      <Button
                        type="submit"                      
                        variant="contained"
                        sx={{ ...Styles.buttonStyle,  ml:4 }}
                      >
                        {title}
                      </Button>
                    </ButtonGroup>
                  </Stack>
                </Box>
              </Box>
            </Box>          
          </Modal>
      </>
    )
  }
}